module.exports = __webpack_public_path__ + "static/media/googlePin8.cec1b237.svg";